import { PageHeader } from "@/components/Common";
import { AvailabilityEditor, AvailabilityView } from "@/components/Availability";
import { useFetch } from "@/lib/api";

export default function CandidateAvailability() {
  const { data, setData } = useFetch("/me/candidate");
  const sched = data?.availability_schedule;
  return (
    <div>
      <PageHeader eyebrow="Interviews" title="My availability" desc="Set the days and times you're free for interviews. Businesses see this when they request an interview." />
      {data && <AvailabilityEditor initial={sched} onSaved={(s) => setData({ ...data, availability_schedule: s })} />}
      <h2 className="mb-3 mt-10 font-display text-xl font-bold">How businesses see it</h2>
      <div className="rounded-md border border-stone-200 bg-white p-6"><AvailabilityView schedule={sched} /></div>
    </div>
  );
}
